import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useCreateCellNode() {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const createCellNode = (guid, cellData, refreshData) => {
    setLoading(true);
    axiosClient
      .put('/InventoryGeo/Cell/Update', {
        guid,
        display: cellData.name,
        arrow: cellData.arrow,
        cellDecreaseType: cellData.cellDecreaseType,
        labelType: cellData.labelType,
      })
      .then(res => {
        if (res.status === 200) {
          const data = {
            // ...res.data.value,
            title: res.data.value.display,
            // children: [],
          };
          refreshData(data);
          enqueueSnackbar(res.data?.message, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, createCellNode];
}
